module.exports = __webpack_public_path__ + "img/side-car3.dc19e9b9.png";